export enum SitesEnum {
  InitialSite = 1,
  AllSites = 2
}
